import React, { useState, useEffect, memo } from "react";
import { Checkbox, Skeleton} from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const TableModalReturnPickupOrders = (props) => {
  const [data , setData] = useState([]);
  
  useEffect(()=>{
    return props?.data && setData(props?.data.map((d, i)=> {return {
      ...d,
      sku: d.sku?d.sku:`D123${i}`,
      selected: false,
      index: i,
      orgQuantity: d.quantity,
      orgPrice: d.price/d.quantity
    }}))
  }, [props.data]);

  useEffect(()=>{
    props.send(data)
  }, [data]);

  const checkOnChange = (value, val) => {
    setData((d)=> d.map((e)=> {
      if(e.index == value.index) {
        return {...e, selected: val.target.checked}
      }
      return e;
    }))
  }

  const cartOnChange = (value, type) => {
    // toFixed(2)
    // setData((d)=> d.map((e)=> {
    //   if(e.index == value.index) {
    //     const newPrice = type === 'min'? orgPrice * --e.quantity : orgPrice * ++e.quantity
    //     return {
    //       ...e,
    //       price: newPrice.toFixed(2)
    //       // price: type === 'min'? (e.price / e.quantity) * --e.quantity : (e.price / e.quantity) * ++e.quantity
    //     }
    //   }
    //   return e;
    // }))
    setData((d)=> d.map((e)=> {
      if(e.index == value.index) {
        return {
          ...e,
          quantity: type === 'min'? --e.quantity : ++e.quantity,
          price: (e.orgPrice * e.quantity).toFixed(2)
        }
      }
      return e;
    }))
  }

   return (
    <div className="customTable">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Image</th>
            <th>Name</th>
            <th>Quantity</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {data && data.map((item, i)=>{
            return <tr key={i} style={{ verticalAlign: "baseline" }}>
              <td><Checkbox checked={item.selected ? true : false} onChange={(val)=>checkOnChange(item, val)}/></td>
              <td>{item?.image?(<img alt="Profile Image" src={item?.image} />):(<Skeleton.Image active />)}</td>
              <td>{item?.name|| "-"}</td>
              <td><div className="cart">
                <MinusOutlined onClick={item?.quantity <= 1 ? "":()=>cartOnChange(item, "min")} />
                {item?.quantity || "0"}
                <PlusOutlined onClick={item?.quantity >= item?.orgQuantity ?"":()=>cartOnChange(item, "add")}/>
              </div></td>
              <td>{item?.price || "-"}</td>
            </tr>
          })}
        </tbody>
      </table>
    </div>
  );
};
export default memo(TableModalReturnPickupOrders);
